import { Input } from "@shared/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@shared/components/ui/tabs";
import { useTranslation } from "react-i18next";
import { SelectUser } from "@/features/users/SelectUser";
import { useAuth } from '@features/auth/contexts/AuthContext';
import HeadLayout from "@shared/layouts/HeadLayout";
import AddNewProduct from "./AddNewProduct";

export function ProductFilter({ onFilter, params }) {
  const { t } = useTranslation();
  const auth = useAuth();

  const handleStatusChange = (value) => {
    const isActive = value === "active";
    onFilter({ isActive });
  };

  // Determine current tab value based on params
  const currentTab = params.isActive === true ? "active" : "inactive";

  return (
    <div className="flex flex-col gap-4 mb-6">
      <HeadLayout title={t("products.products")}>
        {/* Add New Product Button */}
        <AddNewProduct />
      </HeadLayout>
      {/* Status Tabs */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {/* Search Input */}
          <div className="flex justify-end">
            <Input
              type="text"
              placeholder={t("action.search", {
                entity: t("products.product"),
              })}
              onChange={(e) => onFilter({ name_q: e.target.value })}
              className="max-w-md w-[300px] bg-background"
            />
          </div>
          <Tabs value={currentTab} onValueChange={handleStatusChange}>
            <TabsList className="grid w-full grid-cols-2 max-w-[200px]">
              <TabsTrigger value="active">{t("status.active")}</TabsTrigger>
              <TabsTrigger value="inactive">{t("status.inactive")}</TabsTrigger>
            </TabsList>
          </Tabs>
        </div>

        {/* User Selection - Only for Admins */}
        {auth.isAdmin && (
          <div className="flex-shrink-0">
            <SelectUser 
              onSelectUser={(user) => onFilter({ user: user })} 
              showAllOption={true}
            />
          </div>
        )}
      </div>
    </div>
  );
}
